module.exports = __webpack_public_path__ + "img/clas-ingl-01.4e4c2393.jpg";